import { getJsonObject } from "./getJsonObject";
import { FormattedJsonLabel } from "./MenuItemWithJasonLabel.types";

/**
 *  This method sanitizes a json formatted label string on Menu item for aria-labels
 *  It returns the input string as is, if the string is not a valid json string.
 */
export const sanitizeLabel = (label?: string): string | undefined => {
  const jsonObject = getJsonObject(label) as FormattedJsonLabel;
  if (
    jsonObject === undefined ||
    jsonObject.parts === undefined ||
    jsonObject.parts.length === 0
  ) {
    return label;
  }

  return jsonObject.parts.map(({ Text }) => Text).join("");
};
